export const myProfleMallModuleName = 'finance_loan_myProfile_shopMall';
